require('../../modules/es6.array.is-array');
module.exports = require('../../modules/_core').Array.isArray;



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/fn/array/is-array.js
// module id = 1453
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16